import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import spinner from "../../../assets/iconos/spinner4.svg";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import TimeZoneComponent from "../../../components/time-zone-component";
import { countNombreEmpresaPlataforma, countUsernameUsuarioPlataforma, registrarEmpresaPlataforma } from "../../../api/api-empresa-plataforma";
// import Select from "react-select";
// import SwitchComponent from "../../../components/switch-component";
// import LabelConSin from "../../../components/label-con-sin-periodo-prueba";
import { getListMoneda } from "../../../api/api-moneda";
import { useTranslation } from "react-i18next";

export default function EmpresaPlataforma() {
    const location = useLocation();
    const history = useHistory();
    const { t } = useTranslation();
    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmarPassword, setShowConfirmarPassword] = useState(false);
    const [passwordError, setPasswordError] = useState("");
    const [selectedHour, setSelectedHour] = useState("");
    const [cargandoPage, setCargandoPage] = useState(true);
    // const [listaMoneda, setListaMoneda] = useState([]);
    // const [monedaSelected, setMonedaSelected] = useState(null);
    const [formData, setFormData] = useState({
        codigo: '',
        nombre: '',
        telefonoEmpresa: '',
        emailEmpresa: '',
        representante: '',
        telefonoRepresentante: '',
        emailRepresentante: '',
        timeZone: '',
        usuario: '',
        password: '',
        confirmarPassword: '',

        nombreEncargadoCobranza: '',
        cargoCobranza: '',
        telefonoCobranza: '',
        emailCobranza: '',

        precioUnitarioVehiculo: '',
        diaFacturacion: '',
    });

    const charLimits = {
        codigo: 64,
        nombre: 128,
        telefonoEmpresa: 64,
        emailEmpresa: 64,
        representante: 128,
        telefonoRepresentante: 64,
        emailRepresentante: 64,
        timeZone: 8,
        usuario: 64,
        password: 256,
        confirmarPassword: 256,

        nombreEncargadoCobranza: 128,
        cargoCobranza: 128,
        telefonoCobranza: 64,
        emailCobranza: 128,

        diaFacturacion: 2,
    };
    // const [isVisible, setIsVisible] = useState(false);
    // const [shouldRender, setShouldRender] = useState(false);
    const [periodoPrueba, setPeriodoPrueba] = useState(true);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const data = location.state;
            // console.log("data");
            // console.log(data);
            if (data !== undefined && data !== null) {
                setFormData(data.params);
                // setTitulo(data.titulo);
            }
            // const response = await getListMoneda({}, true, null);
            // console.log('response');
            // console.log(response);
            // setListaMoneda(response);
            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    // const handleChangeNumber = (e) => {
    //     const { name, value } = e.target;

    //     setFormData({
    //         ...formData,
    //         [name]: value,
    //     });

    // };

    const handleAtrasClick = () => {
        history.goBack();
    };

    const validarStep2 = () => {
        try {
            let result = { error: true, message: "" };
            let message = "";
            if (formData.usuario.trim().length === 0) {
                message = message + t("alert_debe_ingresar_usuario") + "\n";
            }
            if (formData.password.trim().length === 0) {
                message = message + t("alert_debe_ingresar_password") + '\n';
            }
            if (formData.confirmarPassword.trim().length === 0) {
                message = message + t("alert_debe_ingresar_confirmar_password") + '\n';
            }
            if (message.length > 0) {
                result.error = true;
                result.message = message;
            } else {
                result.error = false;
            }
            return result;
        } catch (err) {
            return { error: true, message: err };
        }
    };

    const createAccount = async (e) => {
        // console.log('createAccount');
        e.preventDefault();
        // lógica para guardar los cambios
        // console.log('formData');
        // console.log(formData);
        const isValid = validarStep2();
        if (isValid.error === true) {
            alert(isValid.message);
            return;
        }
        if (formData.password !== formData.confirmarPassword) {
            setPasswordError(t("alert_passwords_no_coinciden"));
            return;
        }
        // return;
        let objEnviar = {};
        objEnviar.id = formData.id;
        objEnviar.codigo = formData.codigo;
        objEnviar.nombre = formData.nombre;
        objEnviar.telefonoEmpresa = formData.telefonoEmpresa;
        objEnviar.emailEmpresa = formData.emailEmpresa;

        objEnviar.representante = formData.representante;
        objEnviar.telefonoRepresentante = formData.telefonoRepresentante;
        objEnviar.emailRepresentante = formData.emailRepresentante;
        objEnviar.timeZone = selectedHour;

        // objEnviar.precioUnitarioVehiculo = formData.precioUnitarioVehiculo;
        // objEnviar.idMoneda = monedaSelected?.value;
        // objEnviar.diasPeriodoPrueba = formData.diasPeriodoPrueba;
        // objEnviar.periodoPrueba = periodoPrueba;

        objEnviar.nombreEncargadoCobranza = formData.nombreEncargadoCobranza;
        objEnviar.cargoCobranza = formData.cargoCobranza;
        objEnviar.telefonoCobranza = formData.telefonoCobranza;
        objEnviar.emailCobranza = formData.emailCobranza;
        objEnviar.diaFacturacion = formData.diaFacturacion;

        objEnviar.usuario = formData.usuario;
        objEnviar.password = formData.password;
        objEnviar.confirmarPassword = formData.confirmarPassword;
        // console.log('objEnviar');
        // console.log(objEnviar);
        const validUsername = await countUsernameUsuarioPlataforma(objEnviar);
        // console.log('validUsername');
        // console.log(validUsername);
        if (validUsername.error === true) {
            alert('No se pudo verificar el usuario');
            return;
        }
        if (validUsername.total > 0) {
            alert('Usuario ya existe');
            return;
        }
        // return;
        if (objEnviar.id === 0) {
            // console.log('actualizar correo');
            const response = await registrarEmpresaPlataforma(objEnviar);
            // console.log('modificado');
            // console.log(modificado);
            if (response.error === false) {
                alert(t("alert_procesado_correctamente"));
                handleAtrasClick();
            }
            if (response.error === true) {
                alert(t("alert_no_se_pudo_processar") + '\n' + response.message);
            }
        }
    };

    const validarStep1 = () => {
        try {
            let result = { error: true, message: "" };
            let message = "";
            if (formData.nombre.trim().length === 0) {
                message = message + t("alert_debe_ingresar_nombre_empresa") + "\n";
            }
            if (formData.telefonoEmpresa.trim().length === 0) {
                message = message + t("alert_debe_ingresar_telefono_empresa") + '\n';
            }
            if (formData.emailEmpresa.trim().length === 0) {
                message = message + t("alert_debe_ingresar_email_empresa") + '\n';
            }
            if (String(selectedHour).trim().length === 0) {
                message = message + t("alert_debe_seleccionar_timezone") + '\n';
            }
            // if (formData.precioUnitarioVehiculo === undefined || formData.precioUnitarioVehiculo.trim().length === 0) {
            //     message = message + "Debe ingresar precio unitario vehiculo" + '\n';
            // }
            // if (monedaSelected === null || monedaSelected === undefined) {
            //     message = message + "Debe seleccionar moneda" + '\n';
            // }
            if (message.length > 0) {
                result.error = true;
                result.message = message;
            } else {
                result.error = false;
            }
            return result;
        } catch (err) {
            return { error: true, message: err };
        }
    };

    const handleNextStep = async (e) => {
        try {
            // console.log('handleNextStep');
            // console.log(formData);
            e.preventDefault();
            const isValid = validarStep1();
            if (isValid.error === true) {
                alert(isValid.message);
                return;
            }
            if (isValid.error === false) {
                const validNombreEmpresa = await countNombreEmpresaPlataforma(formData);
                // console.log('validNombreEmpresa');
                // console.log(validNombreEmpresa);
                if (validNombreEmpresa.error === true) {
                    alert(t("alert_no_se_pudo_validar_nombre_empresa"));
                    return;
                }
                if (validNombreEmpresa.total > 0) {
                    alert(t("alert_nombre_empresa_ya_existe"));
                    return;
                }
                setStep(2);
            } else {
                alert(isValid.message);
            }
            setLoading(false);
        } catch (err) {
            console.log('handleNextStep err');
            console.log(err);
            setLoading(false);
        }
    };

    const render = () => {
        // console.log('render correo');
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (cargandoPage === false && formData === null) {
                return (
                    <div>
                        <label> Sin data</label>
                    </div>
                );
            }
            return (
                <>
                    {step === 1 && (
                        <div className="w-full bg-white rounded-lg shadow-md p-6">
                            <h2 className="text-2xl font-bold text-left text-[#0F3457] mb-6">{t("title_registrar_empresa")}</h2>
                            {/* <form onSubmit={handleNextStep}> */}
                            <div class="grid grid-cols-12 gap-4">
                                <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nameCompany">
                                        {t("label_codigo")}
                                    </label>
                                    <input
                                        type="text"
                                        id="codigo"
                                        name="codigo"
                                        value={formData.codigo}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder="Enter Code"
                                        maxLength={charLimits.codigo}
                                    />
                                    <p className="text-sm text-gray-500 flex justify-end">{formData?.codigo?.length}/{charLimits.codigo}</p>
                                </div>
                                <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nameCompany">
                                        {t("label_nombre")}<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="nombre"
                                        name="nombre"
                                        value={formData.nombre}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder="Enter Name"
                                        maxLength={charLimits.nombre}
                                    />
                                    <p className="text-sm text-gray-500 flex justify-end">{formData.nombre.length}/{charLimits.nombre}</p>
                                </div>
                                <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nitCompany">
                                        {t("label_telefono_empresa")}<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="telefonoEmpresa"
                                        name="telefonoEmpresa"
                                        value={formData.telefonoEmpresa}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder={t("label_telefono_empresa")}
                                        maxLength={charLimits.telefonoEmpresa}
                                    />
                                    <p className="text-sm text-gray-500 flex justify-end">{formData.telefonoEmpresa.length}/{charLimits.telefonoEmpresa}</p>
                                </div>
                                <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="telephoneCompany">
                                        {t("label_email_empresa")}<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="emailEmpresa"
                                        name="emailEmpresa"
                                        value={formData.emailEmpresa}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder={t("label_email_empresa")}
                                        maxLength={charLimits.emailEmpresa}
                                    />
                                    <p className="text-sm text-gray-500 flex justify-end">{formData.emailEmpresa.length}/{charLimits.emailEmpresa}</p>
                                </div>
                            </div>
                            <div class="grid grid-cols-12 gap-4">
                                <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="addressCompany">
                                        {t("label_representante")}
                                    </label>
                                    <input
                                        type="text"
                                        id="representante"
                                        name="representante"
                                        value={formData.representante}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder={t("label_representante")}
                                        maxLength={charLimits.representante}
                                    />
                                    <p className="text-sm text-gray-500 flex justify-end">{formData.representante.length}/{charLimits.representante}</p>
                                </div>
                                <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="addressCompany">
                                        {t("label_telefono_representante")}
                                    </label>
                                    <input
                                        type="text"
                                        id="telefonoRepresentante"
                                        name="telefonoRepresentante"
                                        value={formData.telefonoRepresentante}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder={t("label_telefono_representante")}
                                        maxLength={charLimits.telefonoRepresentante}
                                    />
                                    <p className="text-sm text-gray-500 flex justify-end">{formData.telefonoRepresentante.length}/{charLimits.telefonoRepresentante}</p>
                                </div>
                                <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="addressCompany">
                                        {t("label_email_representante")}
                                    </label>
                                    <input
                                        type="text"
                                        id="emailRepresentante"
                                        name="emailRepresentante"
                                        value={formData.emailRepresentante}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder={t("label_email_representante")}
                                        maxLength={charLimits.emailRepresentante}
                                    />
                                    <p className="text-sm text-gray-500 flex justify-end">{formData.emailRepresentante.length}/{charLimits.emailRepresentante}</p>
                                </div>
                                <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <TimeZoneComponent
                                        selectedHour={selectedHour}
                                        setSelectedHour={setSelectedHour}
                                    />
                                </div>
                            </div>
                            {/* <div class="grid grid-cols-12 gap-4">
                                <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="precioUnitarioVehiculo">
                                        P/U Vehiculo<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        id="precioUnitarioVehiculo"
                                        name="precioUnitarioVehiculo"
                                        value={formData.precioUnitarioVehiculo}
                                        onChange={handleChangeNumber}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder="P/U Vehiculo"
                                        min={1}
                                    />
                                </div>
                                <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="moneda">
                                        Moneda<span className="text-red-500">*</span>
                                    </label>
                                    <Select
                                        options={listaMoneda}
                                        isSearchable={true} // Boolean props should not be strings
                                        isClearable={true}
                                        value={monedaSelected}
                                        onChange={(event) => setMonedaSelected(event)}
                                        placeholder="Seleccione Moneda"
                                    />
                                </div>
                                <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <LabelConSin periodoPrueba={periodoPrueba} />
                                    <div className="flex justify-between items-center">
                                        <input
                                            type="number"
                                            id="diasPeriodoPrueba"
                                            name="diasPeriodoPrueba"
                                            value={formData.diasPeriodoPrueba}
                                            onChange={handleChangeNumber}
                                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                            placeholder={periodoPrueba ? 'Con ' + "Dias Periodo Prueba" : 'Sin ' + "Dias Periodo Prueba"}
                                            min={1}
                                            disabled={!periodoPrueba}
                                        />
                                        <div className="w-[10px]"></div>
                                        <SwitchComponent isOn={periodoPrueba} handleToggle={() => {
                                            const periodo = !periodoPrueba;
                                            if (periodo === false) {
                                                formData.diasPeriodoPrueba = null;
                                            }
                                            setPeriodoPrueba(periodo);
                                        }} />
                                    </div>
                                </div>
                            </div> */}
                            <br />
                            <h3 className="text-[#0F3457] font-bold" >{t("title_datos_cobranza")}</h3>
                            <hr />
                            <br />
                            <div class="grid grid-cols-12 gap-4">
                                <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nombreEncargadoCobranza">
                                        {t("label_nombre_encargado_cobranza")}
                                    </label>
                                    <input
                                        type="text"
                                        id="nombreEncargadoCobranza"
                                        name="nombreEncargadoCobranza"
                                        value={formData.nombreEncargadoCobranza}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder={t("label_nombre_encargado_cobranza")}
                                        maxLength={charLimits.nombreEncargadoCobranza}
                                    />
                                    <p className="text-sm text-gray-500 flex justify-end">{formData.nombreEncargadoCobranza?.length}/{charLimits.nombreEncargadoCobranza}</p>
                                </div>
                                <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="cargoCobranza">
                                        {t("label_cargo_cobranza")}
                                    </label>
                                    <input
                                        type="text"
                                        id="cargoCobranza"
                                        name="cargoCobranza"
                                        value={formData.cargoCobranza}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder={t("label_cargo_cobranza")}
                                        maxLength={charLimits.cargoCobranza}
                                    />
                                    <p className="text-sm text-gray-500 flex justify-end">{formData.cargoCobranza?.length}/{charLimits.cargoCobranza}</p>
                                </div>
                                <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="telefonoCobranza">
                                        {t("label_telefono_cobranza")}
                                    </label>
                                    <input
                                        type="text"
                                        id="telefonoCobranza"
                                        name="telefonoCobranza"
                                        value={formData.telefonoCobranza}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder="Enter Phone"
                                        maxLength={charLimits.telefonoCobranza}
                                    />
                                    <p className="text-sm text-gray-500 flex justify-end">{formData.telefonoCobranza?.length}/{charLimits.telefonoCobranza}</p>
                                </div>
                                <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="emailCobranza">
                                        {t("label_email_cobranza")}
                                    </label>
                                    <input
                                        type="text"
                                        id="emailCobranza"
                                        name="emailCobranza"
                                        value={formData.emailCobranza}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder="Enter Email"
                                        maxLength={charLimits.emailCobranza}
                                    />
                                    <p className="text-sm text-gray-500 flex justify-end">{formData.emailCobranza?.length}/{charLimits.emailCobranza}</p>
                                </div>
                            </div>
                            <div class="grid grid-cols-12 gap-4">
                                <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="diaFacturacion">
                                        {t("label_dia_facturacion")}
                                    </label>
                                    <input
                                        type="number"
                                        id="diaFacturacion"
                                        name="diaFacturacion"
                                        value={formData.diaFacturacion}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder="Billing Day"
                                        maxLength={charLimits.diaFacturacion}
                                        min={1}
                                    />
                                    <p className="text-sm text-gray-500 flex justify-end">{formData.diaFacturacion?.length}/{charLimits.diaFacturacion}</p>
                                </div>
                            </div>
                            <div className="flex justify-between">
                                <p
                                    onClick={handleAtrasClick}
                                    className="text-center text-[#0F3457] mt-4 cursor-pointer hover:underline"
                                >
                                    {t("label_atras")}
                                </p>
                                <>
                                    {loading === false &&
                                        <button
                                            onClick={handleNextStep}
                                            className="bg-[#84B044] text-white font-semibold py-2 px-4 rounded-lg hover:bg-[#6f9239] transition duration-300"
                                        >
                                            {t("label_siguiente")}
                                        </button>
                                    }
                                    {loading === true &&
                                        <button
                                            className="bg-[#84B044] text-white font-semibold py-2 px-4 rounded-lg hover:bg-[#6f9239] transition duration-300 flex justify-center items-center"
                                        >
                                            <img className="spinner" alt="spinner" src={spinner} />
                                        </button>

                                    }
                                </>
                            </div>
                            {/* </form> */}

                        </div>
                    )}

                    {step === 2 && (
                        <div className="min-h-screen bg-gray-100 flex items-center justify-center">
                            <div className="w-full max-w-md bg-white rounded-lg shadow-md p-6">
                                <h2 className="text-2xl font-bold text-center text-[#0F3457] mb-6">{t("label_crear_cuenta")}</h2>
                                <form onSubmit={createAccount}>
                                    <div className="mb-4">
                                        <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="usuario">
                                            {t("label_usuario")}<span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="usuario"
                                            name="usuario"
                                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                            placeholder="Enter Username"
                                            maxLength={charLimits.usuario}
                                            onChange={handleChange}
                                            value={formData.usuario}
                                        />
                                        <p className="text-sm text-gray-500 flex justify-end">{formData.usuario.length}/{charLimits.usuario}</p>
                                    </div>

                                    <div className="mb-4">
                                        <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="password">
                                            {t("label_password")}<span className="text-red-500">*</span>
                                        </label>
                                        <div className="flex items-center space-x-2">
                                            <input
                                                type={showPassword === false ? "password" : "text"}
                                                id="password"
                                                name="password"
                                                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                                placeholder="Enter password"
                                                maxLength={charLimits.password}
                                                onChange={handleChange}
                                                value={formData.password}
                                            />
                                            {showPassword === true &&
                                                <EyeIcon className="cursor-pointer text-gray-500" width={32} onClick={() => setShowPassword(!showPassword)}
                                                    style={{ transition: "opacity 0.3s ease-in-out", }}
                                                />
                                            }
                                            {showPassword === false &&
                                                <EyeSlashIcon className="cursor-pointer text-gray-500" width={32} onClick={() => setShowPassword(!showPassword)}
                                                    style={{ transition: "opacity 0.3s ease-in-out", }}
                                                />
                                            }
                                        </div>

                                        <p className="text-sm text-gray-500 flex justify-end">{formData.password.length}/{charLimits.password}</p>
                                    </div>

                                    <div className="mb-4">
                                        <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="confirmarPassword">
                                            {t("label_confirmar_password")}<span className="text-red-500">*</span>
                                        </label>
                                        <div className="flex items-center space-x-2">
                                            <input
                                                type={showConfirmarPassword === false ? "password" : "text"}
                                                id="confirmarPassword"
                                                name="confirmarPassword"
                                                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                                placeholder="Confirm password"
                                                maxLength={charLimits.confirmarPassword}
                                                onChange={handleChange}
                                                value={formData.confirmarPassword}
                                            />
                                            {showConfirmarPassword === true &&
                                                <EyeIcon className="cursor-pointer text-gray-500" width={32} onClick={() => setShowConfirmarPassword(!showConfirmarPassword)} />
                                            }
                                            {showConfirmarPassword === false &&
                                                <EyeSlashIcon className="cursor-pointer text-gray-500" width={32} onClick={() => setShowConfirmarPassword(!showConfirmarPassword)} />
                                            }
                                        </div>
                                        <p className="text-sm text-gray-500 flex justify-end">{formData.confirmarPassword.length}/{charLimits.confirmarPassword}</p>
                                    </div>
                                    {passwordError.length > 0 &&
                                        <span className="text-red-500">{passwordError}</span>
                                    }
                                    <button
                                        type="submit"
                                        className="w-full bg-[#84B044] text-white font-semibold py-2 px-4 rounded-lg hover:bg-[#6f9239] transition duration-300"
                                    >
                                        {t("label_registrarse")}
                                    </button>
                                    <p
                                        onClick={() => { setStep(1); }}
                                        className="text-center text-[#0F3457] mt-4 cursor-pointer hover:underline"
                                    >
                                        {t("label_atras")}
                                    </p>
                                </form>
                            </div>
                        </div>
                    )}

                </ >
            );
        } catch (err) {
            console.log('Empresa render err');
            console.log(err);
            return (
                <div>
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }

    return render();
}
